import { Component } from '@angular/core';

@Component({
  selector: 'mafo5-headline',
  templateUrl: './headline.component.html',
  styleUrls: ['./headline.component.scss']
})
export class HeadlineComponent {

}
